import * as routes from '../../constants/apiRoutes'
import generateUrl from '../../network/generate-url'

const invoiceApiRoutes = {
    getInvoices: (invoiceGroup: string, invoiceType: string): string => {
        const params = { invoiceGroup, invoiceType }
        return generateUrl<{ invoiceGroup: string, invoiceType: string }>(routes.getInvoices, params);
    },
    removeInvoice: (invoiceNumber: string): string => {
        const params = { invoiceNumber }
        return generateUrl<{ invoiceNumber: string }>(routes.removeInvoice, params);
    },
    previewInvoice: (invoiceNumber: string): string => {
        const params = { invoiceNumber }
        return generateUrl<{ invoiceNumber: string }>(routes.previewInvoice, params);
    },
    getPendingCharges: (invoiceGroup: string, invoiceType: string ): string => {
        const params = { invoiceGroup, invoiceType }
        return generateUrl<{ invoiceGroup: string, invoiceType: string }>(routes.getPendingInvoices, params);
    },
    getCommercialStagedInvoices: (invoiceType: string): string => {
        const params = { invoiceType }
        return generateUrl<{invoiceType: string}>(routes.getCommercialStagedInvoices, params);
    },
    getCommercialSentInvoices: (invoiceType: string): string => {
        const params = { invoiceType }
        return generateUrl<{ invoiceType: string }>(routes.getCommercialSentInvoices, params);
    },
    approveSelectedInvoices: (): string => {
        const params = { }
        return generateUrl<{}>(routes.approveSelectedInvoices, params);
    },
    ignoreSelectedInvoices: (): string => {
        const params = {}
        return generateUrl<{}>(routes.ignoreSelectedInvoices, params);
    },
    holdSelectedInvoices: (): string => {
        const params = {}
        return generateUrl<{}>(routes.holdSelectedInvoices, params);
    },
    approveStandardInvoices: (invoiceGroup: string): string => {
        const params = { invoiceGroup}
        return generateUrl<{ invoiceGroup: string }>(routes.approveAllStandardInvoices, params);
    },
    approveBatch: (invoiceGroup: string): string => {
      const params = { invoiceGroup };
      return generateUrl<{ invoiceGroup: string }>(routes.approveBatch, params);
  },
    ignoreSelectedCommercialInvoices: (): string => {
        const params = {}
        return generateUrl<{}>(routes.ignoreSelectedCommercialInvoices, params);
    },
    approveSelectedCommercialInvoices: (): string => {
        const params = {}
        return generateUrl<{}>(routes.approveSelectedCommercialInvoices, params);
    },
    approveInvoiceWithUpload:(): string => {
        const params = {}
        return generateUrl<{}>(routes.approveInvoiceWithUpload, params);
    },
    downloadPdfInvoice: (documentKey: string): string => {
	const params = { documentKey }
	return generateUrl<{ documentKey: string }>(routes.downloadPdfInvoice, params);
	},
    getInvoicePdfData: (documentKey: string, download: string): string => {
        const params = { documentKey, download }
        return generateUrl<{ documentKey: string, download: string }>(routes.getInvoicePdfData, params);
    },
    openInvoiceTab: (documentKey: string): string => {
        const params = { documentKey }
        return generateUrl<{ documentKey: string }>(routes.openInvoiceTab, params);
    }
}

export default invoiceApiRoutes
